import { mdiAlertOutline } from '@mdi/js'

export default {
  title: 'Violation',
  to: 'violation-school',
  icon: mdiAlertOutline,
  resource: 'ViolationSchool',
  action: 'read',
}
